import React, { Component } from 'react';
import propTypes from 'prop-types';

import calendarImg from '../../../assets/icons/black/calendar.png';
import phoneImg from '../../../assets/icons/black/phone.png';


export default class ModuleProspect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      touches: false,
      status: false,
      theStatus: '',
    }
  }

  addToFollows = e => {
    e.preventDefault();

    let prospect = {};
    prospect.touches = document.getElementById('touches').value;
    prospect.status = this.state.theStatus;

    this.props.addToFollows(prospect);
  }

  formChange = e => {
    let touchState = this.state.touches;
    let statusState = this.state.status;
    let theStatus = this.state.theStatus;

    if (e.target.id === 'touches' && e.target.value !== '') {
      touchState = true;
    } else if (e.target.id === 'touches' && e.target.value === '') {
      touchState = false;
    }
    if (e.target.id === 'status' && e.target.value !== '') {
      statusState = true;
      theStatus = e.target.value;
    } else if (e.target.id === 'status' && e.target.value === '') {
      statusState = false;
    }

    this.setState({
      touches: touchState,
      status: statusState,
      theStatus: theStatus
    })
  }

  componentDidMount() {
    let buttonStatus = {
      touches: false,
      status: false
    }
    if (this.props.currentRecord['Sales Touches'] && this.props.currentRecord['Sales Touches'] !== '') {
      buttonStatus.touches = true;
    }
    if (this.props.currentRecord['Follow Status'] && this.props.currentRecord['Follow Status'] !== '') {
      buttonStatus.status = true;
    }

    this.setState({
      touches: buttonStatus.touches,
      status: buttonStatus.status
    })
  }

  // Render
  // ----------------------------------------------------
  render() {

    let theRec = this.props.currentRecord;

    if (theRec['Follow Status'] && theRec['Follow Status'] !== '') {
      return (
        <div className="ModuleCard moduleSpecial">
          <div className="inner">
            <div className="inputBlock inputBlock--full">
              <h4>Pipeline</h4>
            </div>

            <div className="inputBlock inputBlock--full">
              <p>Status - {theRec['Follow Status']}</p>
              <p>Last Touch - {theRec['Last Touch']}</p>
              <p>{theRec['Sales Touches'] && theRec['Sales Touches'] !== '' ? 'Sales Touches' + theRec['Sales Touches'] : ""}</p>
            </div>

          </div>
        </div>
      );

    } else {
      return (
        <div className="ModuleCard moduleSpecial">
          <form className="inner" onSubmit={(e)=>this.addToFollows(e)}>
            <div className="inputBlock inputBlock--full">
              <h4>Add to Pipeline</h4>
            </div>

            <div className="inputBlock inputBlock--half">
              <label>Sales Touches</label>
              <input
                type="number"
                id="touches"
                onChange={(e)=>this.formChange(e)}
              />
            </div>
            <div className="inputBlock inputBlock--half">
              <label>Follow Status</label>
              <div className="selectBlock">
                <select id="status" onChange={(e)=>this.formChange(e)}>
                  <option value=""></option>
                  <option value="New">New Lead</option>
                  <option value="Pre-First">Pre-Meeting 1st</option>
                  <option value="Pre-Mid">Pre-Meeting Mid</option>
                  <option value="Pre-Ongoing">Pre-Meeting Ongoing</option>
                  <option value="Pre-Old">Pre-Meeting Older</option>
                  <option value="Post-First">Post-Meeting 1st</option>
                  <option value="Post-Mid">Post-Meeting Mid</option>
                  <option value="Post-Ongoing">Post-Meeting Ongoing</option>
                  <option value="Post-Old">Post-Meeting Older</option>
                </select>
              </div>
            </div>

            <div className="cardTag">
              <button type="submit" className={this.state.touches && this.state.status ? "btn softGrad--black" : "btn softGrad--black disabled"}>Add to Pipeline</button>
            </div>

          </form>
        </div>
      );
    }
  }
}

ModuleProspect.propTypes ={
  serviceScheduleNotes: propTypes.string,
  changeNotesHandler: propTypes.func.isRequired,
  changeRecordHandler: propTypes.func.isRequired,
}



// WEBPACK FOOTER //
// ./src/Franchisees/Records/Modules/ModuleProspect.js